import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import ExtraMileHeader from '../ExtraMileHeader/ExtraMileHeader';
import useDesktopBg from '../../hooks/useDesktopBg';
import './AppShell.css';

export default function AppShell() {
  const { pathname } = useLocation();
  const gameBg = useDesktopBg(
    '/img/halloween/game-Background-MB.jpg',
    '/img/halloween/game-Background.jpg'
  );
  const loginBg = useDesktopBg(
    '/img/halloween/Background-MB.jpg',
    '/img/halloween/Background.jpg'
  );

  const pageBg =
    pathname === '/game' || pathname === '/thank-you'
      ? gameBg
      : pathname === '/welcome'
        ? loginBg
        : null;

  return (
    <div
      className="ddd-user-shell"
      style={pageBg ? { '--page-bg': `url(${pageBg})` } : undefined}
    >
      <ExtraMileHeader />
      <div className="ddd-user-main">
        <Outlet />
      </div>
    </div>
  );
}
